// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"3d6bf896","171":"2e90cbb5","581":"a83af960","760":"d2da4ede","913":"ccbc3c47"}[chunkId] + ".chunk.js";
};